import React, { useEffect } from 'react';
import hreflangService from '../services/hreflangService';

const HreflangProvider = ({ children }) => {
  useEffect(() => {
    // Initialize hreflang links when component mounts
    hreflangService.initializeHreflangLinks();
  }, []);

  return <>{children}</>;
};

export default HreflangProvider;

